import React from 'react';
import PropTypes from 'prop-types';
import './notificationCard.scss';


const NotificationCard = ({
  newBgColor,
  newTextColor,
  notificationHeading,
  notificationData,
  read,
  notificationEventType,
}) => {
  const getStatusStyle = (eventType) => {
    switch ((eventType || '').toLowerCase()) {
    case 'approved':
      return { background: 'var(--colorApprovedBg)', color: 'var(--colorApprovedText)' };
    case 'rejected':
      return { background: 'var(--colorRejectedBg)', color: 'var(--colorRejectedText)' };
    default:
      return { background: 'var(--colorDefaultBg)', color: 'var(--colorDefaultText)' };
    }
  };

  return (
    <div className="notification-card">
      <div className="notification-card__header">
        <div>
          <span
            className="notification-card__status"
            style={getStatusStyle(notificationEventType)}
          >
            {notificationHeading}
          </span>
        </div>
        {!read && (
          <span
            className="notification-card__new"
            style={{
              background: newBgColor,
              color: newTextColor,
            }}
          >
            New
          </span>
        )}
      </div>
      <div className="notification-card__description">
        <span className="notification-card__desc">
          {
            (notificationData || '')
              .replace(/\\/g, '')
              .replace(/^"(.*)"$/, '$1')
          }
        </span>
      </div>
    </div>
  );
};

NotificationCard.propTypes = {
  newBgColor: PropTypes.string,
  newTextColor: PropTypes.string,
  notificationHeading: PropTypes.string,
  notificationData: PropTypes.string,
  read: PropTypes.bool,
  notificationEventType: PropTypes.string,
};

export default NotificationCard;
